import React, { useState, useEffect, useRef } from "react";
import { Container, Col, FormGroup, Label, Input } from 'reactstrap';
import { useSearchParams, useNavigate } from "react-router-dom";
import { Formik, Form, Field } from 'formik';
import { Loading } from '../../share/loading'
import { NumberWithCommas } from '../../share/NumberWithCommas'
import * as Yup from 'yup'
import '../../share/form.css';
import Swal from 'sweetalert2'
// import { NumericFormat } from 'react-number-format';
// import Select from 'react-select';
import { GetVMdDept } from "../../share/api/MasterDataApi";
import { FormikSelect } from "../../share/FormikSelect";
// import DataRegisterComponent from "../../share/DataRegisterComponent";
import { ReplaceNullWithEmptyString } from "../../share/ReplaceNullWithEmptyString";

export function SupportAnnounce5Component() {
    // let year = 2566;
    const formikRef = useRef(null); // ✅ ใช้ useRef เพื่อดึง setFieldValue ภายนอก
    const [searchParams] = useSearchParams();
    let supportId = searchParams.get("req");
    let supportTypeId = searchParams.get("type");
    const [currentSupportForm, setCurrentSupportForm] = useState(null);
    // console.log("currentSupportForm", currentSupportForm);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [userProfile, setUserProfile] = useState(null);
    const [userAuthRegister, setUserAuthRegister] = useState([]);

    const [checkLoading, setCheckLoading] = useState(false);
    // let getYear = new Date().getFullYear();
    // ดึง cookie มาใช้
    const user = JSON.parse(localStorage.getItem("userData"))
    const [deptsData, setDeptsData] = useState([]);
    // const [titleName, setTitleName] = useState([]);
    const [dataAnnounce5, setDataAnnounce5] = useState([]);
    const [conditionOne, setConditionOne] = useState(null);
    const [calculateAmount, setCalculateAmount] = useState(0);

    useEffect(() => {
        GetVMdDept({ setDeptsData, setLoading })
        checkDataAnnounce5()
        getProfile();
    }, [])


    const getProfile = async () => {
        try {
            const res = await fetch("/api/Profile/getProfile", {
                method: "POST",
                headers: { 'token': user.token },
            })
            const resJson = await res.json();

            resJson.dataenum.authorizedList = resJson.dataenum.authRegister;
            setUserProfile(resJson.dataenum);
            setUserAuthRegister(resJson.dataenum.authRegister);
            if (supportId == "0") {
                // ✅ ใช้ setFieldValue ผ่าน formikRef
                formikRef.current?.setFieldValue("deptId", resJson.dataenum.deptId);
                formikRef.current?.setFieldValue("coordinateName", resJson.dataenum.contactorName);
                formikRef.current?.setFieldValue("coordinatePhone", resJson.dataenum.contactorPhone);
                formikRef.current?.setFieldValue("coordinateMobile", resJson.dataenum.phone);
                formikRef.current?.setFieldValue("coordinateFax", resJson.dataenum.fax);
                formikRef.current?.setFieldValue("coordinateEmail", resJson.dataenum.email);
            }

        } catch (e) {
            console.log("err", e)
        }
    };

    useEffect(() => {
        const GetCurrentSupportForm = async () => {
            if (supportId !== "0") {
                let postData = new FormData();
                postData.append("supportId", Number(supportId));
                postData.append("supportTypeId", Number(supportTypeId));
                setLoading(true);
                try {
                    let res = await fetch("/api/SupportForm/getSupportFormData", {
                        method: "POST",
                        body: postData
                    })
                    let resJson = await res.json();
                    if (resJson.status == 1) {
                        resJson.dataenum["customerTypeId"] = Number(user.roldId);
                        resJson.dataenum["registerId"] = Number(user.registerId);
                        resJson.dataenum["announce"] = "5";
                        resJson.dataenum["term"] = true;
                        // setCalculateAmount(resJson.dataenum.amount);
                        setCurrentSupportForm(ReplaceNullWithEmptyString(resJson.dataenum));
                    }

                } catch (e) {
                    // console.log("err", e);
                } finally {
                    setLoading(false);
                }
            } else {
                return;
            }
        };
        GetCurrentSupportForm();
    }, [])
    //ดึง md_support_condition
    useEffect(() => {
        const getCondition = async () => {
            let id = 4;
            try {
                let res = await fetch(`api/SupportForm/getConditionSupport/${id}`)
                let resJson = await res.json();
                console.log(resJson.dataenum);
                // setConditionData(resJson.dataenum);

                resJson.dataenum?.map((condition) => {
                    setConditionOne(condition.condition1);
                    // setConditionTwo(condition.condition2);
                    // setConditionDate(condition.conditionDate);
                })

            } catch (e) {
                console.log('err => ', e)
            }
        }
        getCondition();
    }, [])

    //   คำนวณเงิน
    useEffect(() => {
        function calculateAmountSupport() {
            dataAnnounce5.map((data) => {
                // if (data.avgMan < 100) {
                //     Swal.fire({
                //         icon: "info",
                //         title: "คุณไม่มีสิทธิ์ขอรับเงินช่วยเหลือหรืออุดหนุน",
                //         text: "เนื่องจากมีจำนวนลูกจ้างไม่ถึง 100 คน",
                //         confirmButtonColor: "#0A66C2",
                //         allowOutsideClick: false,
                //         allowEscapeKey: false,
                //         confirmButtonText: "ตกลง",
                //     })
                // }
                setCalculateAmount((data.amount * (Number(conditionOne) / 100)).toFixed(2))


            })
        }
        calculateAmountSupport();
    }, [dataAnnounce5, conditionOne])

    async function checkDataAnnounce5() {
        setCheckLoading(true)
        // let postData = new FormData();
        // postData.append("registerId", user.registerId)
        try {
            let res = await fetch(`api/SupportForm/checkAnnounce5`, {
                method: "POST",
                headers: { 'token': user.token },

                // body: postData
            })
            let resJson = await res.json();
            console.log("resJson.dataenum", resJson.dataenum)

            if (resJson.status === 1) {
                if (resJson.dataenum.length > 0) {
                    setDataAnnounce5(resJson.dataenum)
                } else {
                    Swal.fire({
                        icon: "info",
                        title: "ไม่พบข้อมูล ตามประกาศ 5",
                        text: "โปรดตรวจสอบข้อมูลอีกครั้ง",
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            navigate("/supporting/")
                        }
                    })
                }
            }
        } catch (e) {
            // console.log("err", e)
        } finally {
            setCheckLoading(false)
        }
    }

    useEffect(() => {
        if (supportId == "0") {
            formikRef?.current?.setFieldValue("year1", dataAnnounce5[0]?.year1?.toString());
        }
    }, [dataAnnounce5])


    const initialValues = {
        supportId: "0",
        registerId: Number(user.registerId),
        supportTypeName: "ผู้ประกอบกิจการ",
        supportTypeId: "2",
        announce: "5",
        deptId: "",
        authRegisterId: 0,
        customerTypeId: Number(user.roldId),
        employeeAmount: "",
        amount: calculateAmount,
        paymentName: "",
        fOtherPath: "",
        term: "",
        // year1: "",
    }

    const onSubmit = async (values) => {
        // console.log("values", values)
        let postData = new FormData();
        // postData.append("amount", calculateAmount)
        Object.entries(values).forEach(([key, value]) => {
            if (key.endsWith("amount")) {
                postData.append("amount", calculateAmount)
                // postData.append(key, Number(value).toFixed())
            } else {
                postData.append(key, value);
            }

        });
        // console.log(postData);

        try {
            let res = await fetch("/api/SupportForm/saveSupportForm", {
                method: "POST",
                body: postData
            });

            let resJson = await res.json();
            // console.log(resJson.dataenum);

            if (resJson.status === 1) {
                Swal.fire({
                    icon: "success",
                    title: "บันทึกข้อมูลสำเร็จ",
                    text: "โปรดรอเจ้าหน้าที่ตรวจสอบ",
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                }).then((result) => {
                    if (result.isConfirmed) {
                        navigate("/supporting/")
                    }
                })
            } else if (resJson.status === 4) {
                Swal.fire({
                    icon: "warning",
                    title: "บันทึกข้อมูลไม่สำเร็จ",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    text: `เนื่องจาก ${resJson.message}`,
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "บันทึกข้อมูลไม่สำเร็จ",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    text: `เนื่องจาก ${resJson.message}`,
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                });
            }
        } catch (e) {
            console.log(e)
        }
    }

    const authRegisterOptions = userAuthRegister?.map((item) => ({
        label: item.authFullName,
        value: item.authRegisterId
    })) || [];

    const validationSchema = Yup.object().shape({
        deptId: Yup.string()
            .required("กรุณาเลือกหน่วยงานที่ยื่นคำขอ"),

        employeeAmount: Yup.number()
            .typeError("จำนวนลูกจ้างต้องเป็นตัวเลขเท่านั้น")
            .required("กรุณากรอกจำนวนลูกจ้าง"), //จำนวนลูกจ้าง
        coordinateName: Yup.string().required("กรุณากรอกชื่อผู้ประสานงาน"),
        coordinatePhone: Yup.string().required("กรุณากรอกเบอร์โทรศัพท์"),
        coordinateMobile: Yup.string().required("กรุณากรอกเบอร์โทรศัพท์"),
        coordinateFax: Yup.string().nullable(),
        coordinateEmail: Yup.string()
            .email("รูปแบบอีเมลไม่ถูกต้อง")
            .required("กรุณากรอกอีเมล"),
        amount: Yup.number().nullable(),
        announce: Yup.string().nullable().required("กรุณาเลือกประเภท"),
        paymentName: Yup.string().nullable().required("กรุณากรอก"),
        term: Yup.bool().oneOf([true], "กรุณายอมรับข้อตกลง"),
        fOtherPath: Yup.mixed().when('file', {
            is: value => value !== undefined && value !== null,
            then: Yup.mixed()
                .test('fileFormat', 'กรุณาแนบไฟล์ประเภท pdf, jpg, jpeg', value => {
                    return value && ['application/pdf', 'image/jpg', 'image/jpeg'].includes(value.type);
                })
                .test('fileSize', 'ขนาดไฟล์ต้องไม่เกิน 5MB', value => {
                    const maxSize = 5000000;
                    return !value || value.size <= maxSize;
                }),
        }),
    })

    return (
        <Formik
            innerRef={formikRef} // ✅ ตรงนี้สำคัญ
            initialValues={supportId === "0" ? initialValues : currentSupportForm}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize={supportId == "0" ? false : true}
        >
            {({ setFieldValue, values, touched, errors, isValid, handleBlur, handleChange }) => {
                // console.log("errors =>", errors)
                // console.log("values", values);
                const findPersonalId = () => {
                    if (values.authRegisterId != 0) {
                        const found = userAuthRegister.find(item => item.authRegisterId == values.authRegisterId);
                        return found.authPersonalId
                    }
                }
                return (
                    <Container className="d-flex flex-column justify-content-center align-items-center mb-5">
                        {!loading && !checkLoading ? (
                            <div className="form-border">

                                <Form className='p-5 mb-4'>

                                    <Label
                                        style={{ fontWeight: "bold" }}
                                        className='customer-type text-center px-5'
                                    >
                                        คำขอรับเงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงานตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน พ.ศ. 2545
                                        กรมพัฒนาฝีมือแรงงาน กระทรวงแรงงาน
                                    </Label>
                                    {/* ดึงข้อมูลมาแสดง */}
                                    <Label className="mb-3 input-color">ข้อมูลผู้ขอเงินช่วยเหลือหรืออุดหนุน</Label>
                                    {/* <DataRegisterComponent /> */}
                                    <FormGroup className="mt-3">
                                        <Label for="dept">
                                            ชื่อผู้ขอรับเงินช่วยเหลือหรืออุดหนุน

                                        </Label>
                                        <Col>
                                            <Input
                                                className={"rounded-pill text-center input-color"}
                                                type="text"
                                                disabled
                                                // name="authoriseName"
                                                // id="authoriseName"
                                                // placeholder="กรุณากรอกชื่อ-สกุล"
                                                onBlur={handleBlur}
                                                // onChange={(e) => {
                                                //     handleChange(e);
                                                // }}
                                                value={userProfile?.entrepreneurName ?? "-"}
                                            />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="mt-3">
                                        <Label for="dept">
                                            เลขทะเบียนนิติบุคคล
                                        </Label>
                                        <Col>
                                            <Input
                                                className={"rounded-pill text-center input-color"}
                                                type="text"
                                                disabled
                                                // name="authoriseName"
                                                // id="authoriseName"
                                                // placeholder="กรุณากรอกชื่อ-สกุล"
                                                onBlur={handleBlur}
                                                // onChange={(e) => {
                                                //     handleChange(e);
                                                // }}
                                                value={userProfile?.customerNo ?? "-"}
                                            />
                                        </Col>
                                    </FormGroup>
                                    <FormGroup className="mt-3">
                                        <Label for="dept">
                                            ประเภทกิจการ
                                        </Label>
                                        <Col>
                                            <Input
                                                className={"rounded-pill text-center input-color"}
                                                type="text"
                                                disabled
                                                // name="authoriseName"
                                                // id="authoriseName"
                                                // placeholder="กรุณากรอกชื่อ-สกุล"
                                                onBlur={handleBlur}
                                                // onChange={(e) => {
                                                //     handleChange(e);
                                                // }}
                                                value={userProfile?.businessType ?? "-"}
                                            />
                                        </Col>
                                    </FormGroup>


                                    {/* input เลือกหน่วยงานที่จะยื่นคำขอ */}
                                    <FormGroup className="mt-3">
                                        <Label for="dept">
                                            ยื่นคำขอที่
                                            <span className="require-input">*</span>
                                            {touched.deptId && errors.deptId ? (
                                                <span className="text-left text-danger mx-1">
                                                    {errors.deptId}
                                                </span>
                                            ) : null}
                                        </Label>
                                        <Col>
                                            <Field
                                                name="deptId"
                                                component={FormikSelect}
                                                options={deptsData}
                                                placeholder={<div className="input-color text-center">กรุณาเลือกหน่วยงาน</div>}
                                            />
                                        </Col>
                                    </FormGroup>
                                    {/* ผู้กระทำการแทน คำนำหน้าและชื่อ */}
                                    {/* ผู้กระทำการแทน คำนำหน้าและชื่อ */}
                                    <FormGroup row>
                                        <Label for="titleId">
                                            โดย (ผู้มีอำนาจกระทำการแทน/ผู้รับมอบอำนาจ)
                                            <span className="require-input">*</span>
                                            {touched.authRegisterId &&
                                                errors.authRegisterId ? (
                                                <span className="text-left text-danger px-1">
                                                    {errors.authRegisterId}
                                                </span>
                                            ) : null}

                                        </Label>
                                        <div className="d-flex justify-content-start ">
                                            <div className="flex-grow-1">
                                                <Field
                                                    name="authRegisterId"
                                                    component={FormikSelect}
                                                    options={authRegisterOptions}
                                                    placeholder={<div className="input-color text-center">กรุณาเลือก</div>}
                                                />
                                            </div>

                                        </div>
                                    </FormGroup>
                                    <FormGroup row>
                                        <Label for="titleId">
                                            เลขบัตรประจำตัวประชาชน

                                        </Label>

                                        <div className="d-flex justify-content-start ">
                                            <div className="flex-grow-1">
                                                <Input
                                                    className="rounded-pill text-center input-color"
                                                    type="text"
                                                    name=""
                                                    id=""
                                                    disabled
                                                    value={findPersonalId()}
                                                />

                                            </div>
                                        </div>
                                    </FormGroup>

                                    {/* ประกอบกิจการประเภท และ จำนวนลูกจ้าง */}
                                    <FormGroup className=''>
                                        <Label
                                            for="employeeAmount">จำนวนลูกจ้าง
                                            <span
                                                className="require-input">
                                                *
                                            </span>
                                            {touched.employeeAmount && errors.employeeAmount ?
                                                <span
                                                    className="text-left text-danger mx-1">
                                                    {errors.employeeAmount}
                                                </span> : null
                                            }
                                        </Label>
                                        <Col>
                                            <Input
                                                className={touched.employeeAmount && errors.employeeAmount ?
                                                    "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                }
                                                type="text"
                                                name="employeeAmount"
                                                id="employeeAmount"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    handleChange(e)
                                                }}
                                                maxLength={4}
                                                value={values?.employeeAmount}
                                            />
                                        </Col>
                                    </FormGroup>

                                    {/* ชื่อผู้ประสานงาน */}
                                    <FormGroup>
                                        <Label
                                            for="contact">ชื่อผู้ประสานงาน
                                            <span
                                                className="require-input">
                                                *
                                            </span>

                                        </Label>
                                        <Col>
                                            <Input
                                                className={touched.coordinateName && errors.coordinateName ?
                                                    "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                }
                                                type="text"
                                                name="coordinateName"
                                                id="coordinateName"
                                                onBlur={handleBlur}
                                                disabled
                                                onChange={(e) => {
                                                    handleChange(e)
                                                }}
                                                value={values?.coordinateName}
                                            />

                                        </Col>
                                        <div className="px-3 pt-4">
                                            <FormGroup row>
                                                <Label
                                                    for="coordinatePhone"
                                                    sm={2}
                                                >
                                                    โทรศัพท์
                                                    <span className="require-input">*</span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinatePhone"
                                                        name="coordinatePhone"
                                                        type="text"
                                                        disabled

                                                        className={touched.coordinatePhone && errors.coordinatePhone ?
                                                            "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e)
                                                        }}
                                                        value={values?.coordinatePhone}

                                                    />
                                                </Col>

                                                <Label
                                                    for="coordinateMobile"
                                                    sm={2}
                                                >
                                                    โทรศัพท์มือถือ
                                                    <span className="require-input">*</span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinateMobile"
                                                        name="coordinateMobile"
                                                        disabled

                                                        type="text"
                                                        className={touched.coordinateMobile && errors.coordinateMobile ?
                                                            "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e)
                                                        }}
                                                        value={values?.coordinateMobile}

                                                    />
                                                </Col>
                                            </FormGroup>

                                            <FormGroup row>
                                                <Label
                                                    for="soi"
                                                    sm={2}
                                                >
                                                    โทรสาร
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinateFax"
                                                        name="coordinateFax"
                                                        type="text"
                                                        disabled

                                                        className={touched.coordinateFax && errors.coordinateFax ?
                                                            "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e)
                                                        }}
                                                        value={values?.coordinateFax}

                                                    />
                                                </Col>

                                                <Label
                                                    for="coordinateEmail"
                                                    sm={2}
                                                >
                                                    อีเมล
                                                    <span className="require-input">*</span>
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinateEmail"
                                                        name="coordinateEmail"
                                                        type="text"
                                                        disabled

                                                        className={touched.coordinateEmail && errors.coordinateEmail ?
                                                            "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e)
                                                        }}
                                                        value={values?.coordinateEmail}
                                                    />
                                                </Col>
                                            </FormGroup>
                                        </div>
                                    </FormGroup>
                                    <FormGroup>
                                        {dataAnnounce5?.map((item, i) => (
                                            <FormGroup key={i}>
                                                <div>
                                                    <p className="type-register">นำส่งเงินสมทบกองทุนพัฒนาฝีมือแรงงาน ประจำปี พ.ศ. {item.year2} วันที่นำส่งเงิน {item.receiptDate}</p>
                                                    <p className="type-register">เป็นจำนวนเงิน<span className="mx-1">{NumberWithCommas(item.amount)}</span>บาท</p>
                                                </div>
                                                <p className="type-register">ในปี พ.ศ. {item.year1} (ปีถัดมา) มีลูกจ้างเฉลี่ยรวมทั้งสิ้น จำนวน <span className="mx-1">{NumberWithCommas(item.avgMan)}</span> คน ร้อยละ {item.perc}  จำนวน <span className="mx-1">{item.lawTrainMan}</span> คน</p>
                                                <p className="type-register">ได้ดำเนินการพัฒนาฝีมือแรงงานให้แก่ลูกจ้างครบตามสัดส่วนที่กฎหมายกำหนด รวมจำนวน <span className="mx-1">{item.spkTrainMan} คน </span>ดังนี้ </p>
                                                <div className="px-1">
                                                    <ul>
                                                        <li>
                                                            <div className="d-flex justify-content-start">
                                                                <span className="type-register">จัดให้มีการฝึกอบรมฝีมือแรงงาน จำนวน</span>
                                                                <span className="type-register mx-1">{item.train ? item.train : "-"} คน</span>
                                                            </div>

                                                        </li>
                                                        <li>
                                                            <div className="d-flex justify-content-start">
                                                                <span className="type-register">ผ่านการทดสอบมาตรฐานฝีมือแรงงานแห่งชาติ จำนวน</span>
                                                                <span className="type-register mx-1">{item.test ? item.test : "-"} คน</span>
                                                            </div>
                                                        </li>
                                                        <li>
                                                            <div className="d-flex justify-content-start">
                                                                <span className="type-register">ผ่านการรับรองความรู้ความสามารถ จำนวน</span>
                                                                <span className="type-register mx-1">{item.oloc ? item.oloc : "-"} คน</span>
                                                            </div>

                                                        </li>
                                                    </ul>
                                                </div>
                                            </FormGroup>
                                        ))}

                                    </FormGroup>
                                    {/* ความประสงค์ขอรับเงิน */}
                                    <FormGroup className='mt-3'>
                                        <Label>
                                            มีความประสงค์ขอรับเงินช่วยเหลืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงานตามพระราชบัญญัติส่งเสริมการพัฒนาฝีมือแรงงาน พ.ศ. 2545 เป็นจำนวนเงินทั้งสิ้น(ร้อยละ 25 ของเงินสมทบที่นำส่งตามข้อ 2)
                                            <span
                                                className="require-input">
                                                *
                                            </span>
                                            {touched.amount && errors.amount ?
                                                <span
                                                    className="text-left text-danger px-1">
                                                    {errors.amount}
                                                </span>
                                                : null
                                            }
                                        </Label>
                                        <Input
                                            id="amount"
                                            name="amount"
                                            type="text"
                                            disabled={true}
                                            className={touched.amount && errors.amount ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                            }
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={NumberWithCommas(Number(calculateAmount))}

                                        />
                                    </FormGroup>

                                    <FormGroup>
                                        <Label>
                                            โดยขอรับเช็คขีดคร่อมสั่งจ่ายในนาม
                                            <span
                                                className="require-input">
                                                *
                                            </span>
                                            {touched.paymentName && errors.paymentName ?
                                                <span
                                                    className="text-left text-danger px-1">
                                                    {errors.paymentName}
                                                </span>
                                                : null
                                            }
                                        </Label>
                                        <Input
                                            id="paymentName"
                                            name="paymentName"
                                            type="text"
                                            className={touched.paymentName && errors.paymentName ?
                                                "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                            }
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                            }}
                                            value={values?.paymentName}

                                        />
                                    </FormGroup>

                                    {/* <FormGroup>
                                        <Label>
                                            หนังสือมอบอำนาจพร้อมติดอากรแสตมป์ (กรณีมอบอำนาจ)

                                        </Label>
                                        <Input
                                            id="fAuthrisePath"
                                            name="fAuthrisePath"
                                            type="file"
                                            className="rounded-pill text-center input-color"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                                if (e.target && e.target.files[0]) {
                                                    setFieldValue("fAuthrisePath", e.target.files[0]);
                                                }
                                            }}
                                        // value={values.fAuthrisePath}

                                        />
                                    </FormGroup> */}

                                    {/* <FormGroup>
                                        <Label
                                            for="fAuthriseIdCardPath">
                                            สำเนาบัตรประชาชนของผู้มอบอำนาจ (กรณีมอบอำนาจ)

                                        </Label>
                                        <Input
                                            id="fAuthriseIdCardPath"
                                            name="fAuthriseIdCardPath"
                                            type="file"
                                            className="rounded-pill text-center input-color"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                                if (e.target && e.target.files[0]) {
                                                    setFieldValue("fAuthriseIdCardPath", e.target.files[0]);
                                                }
                                            }}
                                        // value={values.fAuthriseIdCardPath}

                                        />
                                    </FormGroup> */}

                                    <FormGroup>
                                        <Label>
                                            เอกสารอื่นๆ (ถ้ามี)
                                        </Label>
                                        <Input
                                            id="fOtherPath"
                                            name="fOtherPath"
                                            type="file"
                                            className="rounded-pill text-center input-color"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                handleChange(e)
                                                if (e.target && e.target.files[0]) {
                                                    setFieldValue("fOtherPath", e.target.files[0]);
                                                }
                                            }}
                                        // value={values.fOtherPath}

                                        />
                                    </FormGroup>

                                    {/* term */}
                                    <div className='d-flex'>
                                        <Input
                                            type="checkbox"
                                            invalid={errors.term ? true : false}
                                            name="term"
                                            id="term"
                                            onBlur={handleBlur}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setFieldValue("term", true)
                                                } else {
                                                    setFieldValue("term", false)
                                                }
                                                // handleChange(e)
                                            }}
                                            checked={values?.term}
                                        />
                                        <Label
                                            for="term"
                                            className='mx-2 customer-type'
                                        >
                                            ข้าพเจ้ารับรองว่าข้อความดังกล่าวข้างต้นและเอกสารหลักฐานที่แนบคำขอถูกต้องและเป็นความจริงทุกประการ
                                        </Label>

                                    </div>

                                    <div className='d-flex justify-content-center align-items-center mt-5'>
                                        <button
                                            type="submit"
                                            disabled={!isValid && (values?.term ? false : true)}
                                            className='btn-blue px-4 w-25'
                                        >
                                            ส่งคำขอ
                                        </button>
                                    </div>

                                </Form>
                            </div>

                        ) : (
                            <Loading />
                        )}


                    </Container>


                )
            }}



        </Formik>

    );

}
